import React from "react";
import AddTag from "./add-tag";

class AddTagController extends React.Component{

    componentDidMount(){
        if(this.props.body.tags && this.props.body.type === 'post'){
            let ks = {};
            this.props.body.tags.forEach(element => {
                if(!ks[element])
                    ks[element] = 1;
                ks[element] += 1;
            });
            this.props.setTagsToSelected(ks);
        }
        else if(this.props.body.tags && this.props.body.type === 'page'){
            let ks = {};
            this.props.body.tags.forEach(element => {
                if(!ks[element])
                    ks[element] = 1;
                ks[element] += 1;
            });
            this.props.setAllTagsToSelected(ks);
        }
        else{
            this.props.setTagsToSelected([]);
        }
        this.props.getCompanyTags(this.props.companyId);
    }

    componentDidUpdate(){
        if(!this.props.tags && this.props.companyId)
            this.props.getCompanyTags(this.props.companyId);
    }

    getFeedType = (page) => {
        switch(page){
            case 'Documents':
                return 'main'
            case 'Favourite':
                return 'favourite_auto'
            case 'FavouritePublications':
                return 'favourite_manual'
            case 'BlackList':
                return 'blacklisted'
            case 'RecycleBin':
                return 'deleted'
            default:

        }
    }

    render(){
        return <AddTag {...this.props} getFeedType={this.getFeedType}/>
    }

}

export default AddTagController;